export default "__VITE_ASSET__5308f27d__"